import { moduleNames } from '../../constants';

export const getUserProducts = ({ isLegacyUser, privileges, isAgentMetricsUser, isAgentProductionEnabled }) => {
    if (isLegacyUser) {
        return [ moduleNames.proficiencyMetrics ];
    }
    if (isAgentMetricsUser) {
        const amProducts = [];
        if (isAgentProductionEnabled) amProducts.push(moduleNames.agentProduction);
        amProducts.push(moduleNames.marketShare, moduleNames.marketDynamics);
        return amProducts;
    }
    return privileges?.userProducts || [];
};
